export default {
  title: 'Paramètres du Profil',
  subtitle: 'Gérez les informations de votre compte et vos préférences.',
  personalInfo: 'Informations personnelles',
  accountSettings: 'Paramètres du compte',
  displayName: 'Nom d\'affichage',
  email: 'Email',
  nextcloudId: 'ID Nextcloud',
  role: 'Rôle',
  status: 'Statut',
  userId: 'ID Utilisateur',
  active: 'Actif',
  inactive: 'Inactif',
  permissions: 'Permissions',
  appSettings: 'Paramètres de l\'application',
  notifications: 'Notifications push',
  installApp: 'Installer l\'application',
  installAppDescription: 'Pour installer l\'application, suivez les instructions fournies.',
};
